webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/Markus/Documents/GitHub/address-book/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListOfAddresses_vue__ = __webpack_require__(/*! ./ListOfAddresses.vue */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetailedInfo_vue__ = __webpack_require__(/*! ./DetailedInfo.vue */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddAddress_vue__ = __webpack_require__(/*! ./AddAddress.vue */ 26);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'list-of-addresses': __WEBPACK_IMPORTED_MODULE_0__ListOfAddresses_vue__["a" /* default */],
    'detailed-info': __WEBPACK_IMPORTED_MODULE_1__DetailedInfo_vue__["a" /* default */],
    'add-address': __WEBPACK_IMPORTED_MODULE_2__AddAddress_vue__["a" /* default */]
  },
  data: function data() {
    return {
      addressList: [{
        name: "Bengt Persson",
        address: {
          street: "Götaängsvägen 32",
          zip: "30253",
          city: "Göteborg"
        },
        phone: "0731234567",
        email: "Bengt.Persson@gmail.com"
      }, {
        name: "Olof Nilsson",
        address: {
          street: "Valandsgatan 23",
          zip: "41123",
          city: "Göteborg"
        },
        phone: "0731223512",
        email: "Olof.Nilsson@gmail.com"
      }, {
        name: "Evert Ragnhildsson",
        address: {
          street: "Kungsgatan 22",
          zip: "41321",
          city: "Malmö"
        },
        phone: "0731222351",
        email: "Evert@gmail.com"
      }, {
        name: "Kerstin Nilsson",
        address: {
          street: "Valandsgatan 23",
          zip: "41123",
          city: "Göteborg"
        },
        phone: "0731231419",
        email: "Kerstin.Nilsson@gmail.com"
      }],
      selectedIndex: 0,
      showAddAddress: false
    };
  }, // data
  methods: {
    recieveSelection: function recieveSelection(obj) {
      this.selectedIndex = this.addressList.findIndex(function (element) {
        return element.name == obj.name;
      });
      this.showAddAddress = false;
    },

    recieveAddress: function recieveAddress(obj) {
      this.addressList.push(obj);
    },

    updateAddress: function updateAddress(obj) {
      this.addressList[this.selectedIndex].name = obj.name;
      this.addressList[this.selectedIndex].address.street = obj.address.street;
      this.addressList[this.selectedIndex].address.zip = obj.address.zip;
      this.addressList[this.selectedIndex].address.city = obj.address.city;
      this.addressList[this.selectedIndex].phone = obj.phone;
      this.addressList[this.selectedIndex].email = obj.email;
    },

    toggleAddAddress: function toggleAddAddress(event) {
      if (this.showAddAddress) {
        this.showAddAddress = false;
      } else {
        this.showAddAddress = true;
      }
    } //methods
  } //export

});

/***/ }),
/* 4 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/Markus/Documents/GitHub/address-book/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ListOfAddresses.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['address'],
  data: function data() {
    return {};
  }, // data
  methods: {
    selectedInfo: function selectedInfo(name) {
      this.$emit("send-select", {
        name: name
      });
    } //methods
  } //export

});

/***/ }),
/* 5 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/Markus/Documents/GitHub/address-book/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DetailedInfo.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selected', "addressList"],
  data: function data() {
    return {
      clickedInfo: {
        name: false,
        street: false,
        zip: false,
        city: false,
        phone: false,
        email: false
      },
      inputAddress: {
        name: this.addressList[this.selected].name,
        address: {
          street: this.addressList[this.selected].address.street,
          zip: this.addressList[this.selected].address.zip,
          city: this.addressList[this.selected].address.city
        },
        phone: this.addressList[this.selected].phone,
        email: this.addressList[this.selected].email
      }
    };
  }, // data
  methods: {
    inputSwitch: function inputSwitch(info) {
      this.clickedInfo[info] = true;
    },
    spanSwitch: function spanSwitch(info) {
      this.clickedInfo[info] = false;
      this.updateAddress();
    },
    updateInputValues: function updateInputValues() {
      this.inputAddress = {
        name: this.addressList[this.selected].name,
        address: {
          street: this.addressList[this.selected].address.street,
          zip: this.addressList[this.selected].address.zip,
          city: this.addressList[this.selected].address.city
        },
        phone: this.addressList[this.selected].phone,
        email: this.addressList[this.selected].email
      };
    },
    updateAddress: function updateAddress() {
      this.$emit("update-address", this.inputAddress);
    }
  }, //methods
  watch: {
    selected: function selected(newVal, oldVal) {
      this.updateInputValues();
    } //watch
  } //export default

});

/***/ }),
/* 6 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/Markus/Documents/GitHub/address-book/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AddAddress.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      newAddress: {
        name: "",
        address: {
          street: "",
          zip: "",
          city: ""
        },
        phone: "",
        email: ""
      }
    };
  }, // data
  methods: {
    addAddress: function addAddress() {
      var obj = {
        name: this.newAddress.name,
        address: {
          street: this.newAddress.address.street,
          zip: this.newAddress.address.zip,
          city: this.newAddress.address.city
        },
        phone: this.newAddress.phone,
        email: this.newAddress.email
      };
      this.$emit("send-address", obj);
    },
    closeAddAddress: function closeAddAddress() {
      this.$emit("close-add-address");
    } //methods
  } //export

});

/***/ }),
/* 7 */
/*!************************************************************!*\
  !*** multi ./src/pwa.js ./src/polyfills.js ./src/index.js ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! /Users/Markus/Documents/GitHub/address-book/src/pwa.js */8);
__webpack_require__(/*! /Users/Markus/Documents/GitHub/address-book/src/polyfills.js */10);
module.exports = __webpack_require__(/*! /Users/Markus/Documents/GitHub/address-book/src/index.js */15);


/***/ }),
/* 8 */
/*!********************!*\
  !*** ./src/pwa.js ***!
  \********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(/*! offline-plugin/runtime */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  onUpdateReady: function onUpdateReady() {
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  }
});

/***/ }),
/* 9 */,
/* 10 */
/*!**************************!*\
  !*** ./src/polyfills.js ***!
  \**************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

if (!window.Promise) {
  window.Promise = __webpack_require__(/*! promise-polyfill */ 11);
}

Object.assign = __webpack_require__(/*! object-assign */ 14);

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App_vue__ = __webpack_require__(/*! ./components/App.vue */ 17);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__components_App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 16 */,
/* 17 */
/*!********************************!*\
  !*** ./src/components/App.vue ***!
  \********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Markus_Documents_GitHub_address_book_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/Markus/Documents/GitHub/address-book/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2695b540_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2695b540","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 29);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2695b540","scoped":false,"hasInlineConfig":true}!normalize.css/normalize.css */ 18)
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2695b540","scoped":false,"hasInlineConfig":true}!../main.css */ 19)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Markus_Documents_GitHub_address_book_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2695b540_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */,
/* 19 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2695b540","scoped":false,"hasInlineConfig":true}!./src/main.css ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/*!********************************************!*\
  !*** ./src/components/ListOfAddresses.vue ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Markus_Documents_GitHub_address_book_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ListOfAddresses_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/Markus/Documents/GitHub/address-book/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ListOfAddresses.vue */ 4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49223ab2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListOfAddresses_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-49223ab2","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ListOfAddresses.vue */ 22);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-49223ab2","scoped":true,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ListOfAddresses.vue */ 21)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49223ab2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Markus_Documents_GitHub_address_book_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ListOfAddresses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49223ab2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListOfAddresses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49223ab2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ListOfAddresses.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49223ab2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListOfAddresses.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.address),function(item){return _c('li',{on:{"click":function($event){_vm.selectedInfo(item.name)}}},[_vm._v(_vm._s(item.name))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 23 */
/*!*****************************************!*\
  !*** ./src/components/DetailedInfo.vue ***!
  \*****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Markus_Documents_GitHub_address_book_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DetailedInfo_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/Markus/Documents/GitHub/address-book/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./DetailedInfo.vue */ 5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e138f278_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailedInfo_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-e138f278","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./DetailedInfo.vue */ 25);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-e138f278","scoped":true,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DetailedInfo.vue */ 24)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e138f278"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Markus_Documents_GitHub_address_book_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DetailedInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e138f278_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailedInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e138f278","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DetailedInfo.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e138f278","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailedInfo.vue ***!
  \*****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Name: \n      "),(_vm.clickedInfo.name)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputAddress.name),expression:"inputAddress.name"}],attrs:{"type":"text"},domProps:{"value":(_vm.inputAddress.name)},on:{"mouseout":function($event){_vm.spanSwitch('name')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputAddress, "name", $event.target.value)}}}):_c('span',{on:{"click":function($event){_vm.inputSwitch('name')}}},[_vm._v(_vm._s(_vm.addressList[_vm.selected].name))])]),_vm._v(" "),_c('p',[_vm._v("Street: \n      "),(_vm.clickedInfo.street)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputAddress.address.street),expression:"inputAddress.address.street"}],attrs:{"type":"text"},domProps:{"value":(_vm.inputAddress.address.street)},on:{"mouseout":function($event){_vm.spanSwitch('street')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputAddress.address, "street", $event.target.value)}}}):_c('span',{on:{"click":function($event){_vm.inputSwitch('street')}}},[_vm._v(_vm._s(_vm.addressList[_vm.selected].address.street))])]),_vm._v(" "),_c('p',[_vm._v("Zip: \n      "),(_vm.clickedInfo.zip)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputAddress.address.zip),expression:"inputAddress.address.zip"}],attrs:{"type":"text"},domProps:{"value":(_vm.inputAddress.address.zip)},on:{"mouseout":function($event){_vm.spanSwitch('zip')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputAddress.address, "zip", $event.target.value)}}}):_c('span',{on:{"click":function($event){_vm.inputSwitch('zip')}}},[_vm._v(_vm._s(_vm.addressList[_vm.selected].address.zip))])]),_vm._v(" "),_c('p',[_vm._v("City: \n      "),(_vm.clickedInfo.city)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputAddress.address.city),expression:"inputAddress.address.city"}],attrs:{"type":"text"},domProps:{"value":(_vm.inputAddress.address.city)},on:{"mouseout":function($event){_vm.spanSwitch('city')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputAddress.address, "city", $event.target.value)}}}):_c('span',{on:{"click":function($event){_vm.inputSwitch('city')}}},[_vm._v(_vm._s(_vm.addressList[_vm.selected].address.city))])]),_vm._v(" "),_c('p',[_vm._v("Phone: \n      "),(_vm.clickedInfo.phone)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputAddress.phone),expression:"inputAddress.phone"}],attrs:{"type":"text"},domProps:{"value":(_vm.inputAddress.phone)},on:{"mouseout":function($event){_vm.spanSwitch('phone')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputAddress, "phone", $event.target.value)}}}):_c('span',{on:{"click":function($event){_vm.inputSwitch('phone')}}},[_vm._v(_vm._s(_vm.addressList[_vm.selected].phone))])]),_vm._v(" "),_c('p',[_vm._v("Email: \n      "),(_vm.clickedInfo.email)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputAddress.email),expression:"inputAddress.email"}],attrs:{"type":"text"},domProps:{"value":(_vm.inputAddress.email)},on:{"mouseout":function($event){_vm.spanSwitch('email')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputAddress, "email", $event.target.value)}}}):_c('span',{on:{"click":function($event){_vm.inputSwitch('email')}}},[_vm._v(_vm._s(_vm.addressList[_vm.selected].email))])]),_vm._v(" "),_c('p',{attrs:{"id":"userInfo"}},[_vm._v("(Click to edit)")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 26 */
/*!***************************************!*\
  !*** ./src/components/AddAddress.vue ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Markus_Documents_GitHub_address_book_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_AddAddress_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/Markus/Documents/GitHub/address-book/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AddAddress.vue */ 6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b8511a3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAddress_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1b8511a3","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AddAddress.vue */ 28);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1b8511a3","scoped":true,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AddAddress.vue */ 27)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b8511a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Markus_Documents_GitHub_address_book_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_AddAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b8511a3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b8511a3","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AddAddress.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b8511a3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddAddress.vue ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Add Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAddress.name),expression:"newAddress.name"}],attrs:{"type":"text","placeholder":"name"},domProps:{"value":(_vm.newAddress.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAddress, "name", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAddress.address.street),expression:"newAddress.address.street"}],attrs:{"type":"text","placeholder":"street"},domProps:{"value":(_vm.newAddress.address.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAddress.address, "street", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAddress.address.zip),expression:"newAddress.address.zip"}],attrs:{"type":"text","placeholder":"zip"},domProps:{"value":(_vm.newAddress.address.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAddress.address, "zip", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAddress.address.city),expression:"newAddress.address.city"}],attrs:{"type":"text","placeholder":"city"},domProps:{"value":(_vm.newAddress.address.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAddress.address, "city", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAddress.phone),expression:"newAddress.phone"}],attrs:{"type":"text","placeholder":"phone"},domProps:{"value":(_vm.newAddress.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAddress, "phone", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAddress.email),expression:"newAddress.email"}],attrs:{"type":"text","placeholder":"email"},domProps:{"value":(_vm.newAddress.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAddress, "email", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"button leftButton",on:{"click":_vm.addAddress}},[_vm._v("Add")]),_vm._v(" "),_c('button',{staticClass:"button rightButton",on:{"click":_vm.closeAddAddress}},[_vm._v("Close")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 29 */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2695b540","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"page",attrs:{"id":"leftPage"}},[_c('list-of-addresses',{attrs:{"address":_vm.addressList},on:{"send-select":_vm.recieveSelection}}),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":_vm.toggleAddAddress}},[_vm._v("New")])],1),_vm._v(" "),_c('div',{staticClass:"page",attrs:{"id":"rightPage"}},[(_vm.showAddAddress)?_c('add-address',{on:{"send-address":_vm.recieveAddress,"close-add-address":_vm.toggleAddAddress}}):_c('detailed-info',{attrs:{"selected":_vm.selectedIndex,"addressList":_vm.addressList},on:{"update-address":_vm.updateAddress}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[7]);


// WEBPACK FOOTER //
// client.77677036.js